"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var UserVerificationStatus;
(function (UserVerificationStatus) {
    UserVerificationStatus["UNVERIFIED"] = "UNVERIFIED";
    UserVerificationStatus["WAITING_FOR_APPROVAL"] = "WAITING_FOR_APPROVAL";
    UserVerificationStatus["VERIFIED"] = "VERIFIED";
})(UserVerificationStatus = exports.UserVerificationStatus || (exports.UserVerificationStatus = {}));
class UserVerificationProvider extends DataProvider_1.default {
    get fragments() {
        return {
            UserVerification: () => `
        ... on UserVerification {
          userId
          status
          idPhoto {
            ${this.getFragment("File")}
          }
          photoWithId {
            ${this.getFragment("File")}
          }
        }
      `,
        };
    }
    search({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.query({
                query: graphql_tag_1.default `
        query UserVerificationFind($data: InputUserVerificationSearch!) {
          userVerificationFind(data: $data) {
            result {
              ${this.getFragment("UserVerification")}
            }
            hasNextPage
            hasPrevPage
            page
            size
            totalPages
            totalRecords
          }
        }
      `,
                variables: { data },
            });
            return response.data.userVerificationFind;
        });
    }
    start(userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation UserVerificationStart($userId: ID!) {
          userVerificationStart(userId: $userId)
        }
      `,
                variables: { userId },
            });
            return response.data.userVerificationStart;
        });
    }
    approve({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation UserVerificationApprove($data: InputUserVerification!) {
          userVerificationApprove(data: $data)
        }
      `,
                variables: { data },
            });
            return response.data.userVerificationApprove;
        });
    }
    decline({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation UserVerificationDecline($data: InputUserVerification!) {
          userVerificationDecline(data: $data)
        }
      `,
                variables: { data },
            });
            return response.data.userVerificationDecline;
        });
    }
}
exports.UserVerificationProvider = UserVerificationProvider;
//# sourceMappingURL=UserVerificationProvider.js.map